import { useNavigate } from "react-router-dom";
import { SignOut, ShieldStar, Ticket } from "@phosphor-icons/react";
import { useAuth } from "@/lib/auth";

export default function UserMenu() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  if (!user) return null;

  const handleLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };

  const initials = (user.name || user.email || "?").trim().charAt(0).toUpperCase();
  const passLabel = user.role === "admin"
    ? "Account"
    : user.tier === "full"
      ? `Pass · ${user.builds_remaining == null ? "∞" : user.builds_remaining} builds`
      : "Free Taster";

  return (
    <div className="flex items-center gap-2" data-testid="user-menu">
      {passLabel && (
        <button onClick={() => navigate("/account")} data-testid="pass-status-pill" title="Account & billing"
          className={`hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold uppercase tracking-wider rounded-full transition-colors ${
            user.tier === "full" ? "text-emerald-800 bg-emerald-50 hover:bg-emerald-100" : "text-amber-800 bg-amber-50 hover:bg-amber-100"
          }`}>
          <Ticket size={13} weight="duotone" /> {passLabel}
        </button>
      )}
      {user.role === "admin" && (
        <button onClick={() => navigate("/admin")} data-testid="admin-link"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-semibold border border-gray-300 hover:border-gray-900 transition-colors">
          <ShieldStar size={16} weight="duotone" /> Admin
        </button>
      )}
      <span className="hidden sm:flex items-center gap-2 pl-1" data-testid="user-identity" title={user.email}>
        {user.picture ? (
          <img src={user.picture} alt="" className="w-6 h-6 rounded-full object-cover" referrerPolicy="no-referrer" />
        ) : (
          <span className="w-6 h-6 rounded-full bg-gray-950 text-white text-xs font-bold flex items-center justify-center">{initials}</span>
        )}
        <span className="text-sm font-semibold text-gray-700 max-w-[140px] truncate">{user.name || user.email}</span>
      </span>
      <button onClick={handleLogout} data-testid="logout-button" title="Sign out"
        className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-semibold text-gray-500 hover:text-gray-900 transition-colors">
        <SignOut size={16} weight="duotone" /> <span className="hidden sm:inline">Sign out</span>
      </button>
    </div>
  );
}
